import { EmProductConfigurator } from './modules/EmProductConfig';

document.addEventListener('DOMContentLoaded', () => {
	window.emProductConfig = [];
	const productConfig = document.querySelector('.product-configurator--content');
	if (productConfig) {
		const key = productConfig.id.replace('product-config-', '');
		window.emProductConfig[key] = new EmProductConfigurator(productConfig);
	}
});